import * as React from 'react';
import styled from 'styled-components';
import {
  compose,
  space,
  color,
  layout,
  typography,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.894 5.106a9.75 9.75 0 00-13.789 0c-2.707 2.707-3.478 6.606-2.34 9.999a.75.75 0 101.423-.478 8.241 8.241 0 011.978-8.46 8.252 8.252 0 0110.708-.825l-.868.29a.75.75 0 10.474 1.423l2.12-.707a.75.75 0 00.294-1.242zM10.56 9.703v4.592L14.441 12l-3.882-2.295.382-.646-.382.645zm.764-1.29A1.5 1.5 0 009.06 9.704v4.591a1.5 1.5 0 002.264 1.291l3.881-2.295a1.5 1.5 0 000-2.582l-3.881-2.296zm8.961.01a.75.75 0 01.95.472c1.138 3.395.367 7.292-2.34 10a9.75 9.75 0 01-13.789 0 .75.75 0 01.294-1.242l2.12-.707a.75.75 0 01.475 1.422l-.868.29a8.252 8.252 0 0010.707-.824 8.24 8.24 0 001.979-8.461.75.75 0 01.472-.95z"
        clipRule="evenodd"
      />
    </svg>
  );
});
export const IconSystemV2TeacherOverviewPlay = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
